import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { Card, CardMedia, Grid, Typography } from "@mui/material";
import { uniq } from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import Select from "../../../components/Select/Select";
import {
  clinicReassignAppointment,
  clinicRescheduleAppointment,
  getAppointmentsByVetIdAndDate,
  getAvailabilityByVetIdAndType,
} from "../../../redux/reducers/clinicSlice";
import { getVetHolidaysById } from "../../../redux/reducers/doctorSlice";
import { hideLoader, showLoader } from "../../../redux/reducers/loaderSlice";
import { AppColors } from "../../../util/AppColors";
import { appointmentLaterList, appointmentList } from "../../../util/dropList";
import {
  adjustTime,
  getAllDatesFromArray,
  getRequiredSlotList,
  getTimeDiffInMins,
  getUpcoming60Dates,
} from "../../../util/function";

const cardSty = {
  borderRadius: 1,
  padding: 2,
  borderTopColor: AppColors.appPrimary,
};

const initBookValues = {
  bookingType: "Phone",
  consultationMode: "Physical",
  serviceType: null,
  reason: "",
  vetName: null,
  appointmentOption: "",
  date: new Date(),
  assignedUsers: [],
};

const RescheduleReassign = ({
  open,
  onClose,
  modalData,
  isReassign,
  onSuccess,
  vets,
  clinicVets,
  selectedTab,
}) => {
  const dispatch = useDispatch();
  const [bookValues, setBookValues] = useState(initBookValues);
  const [selectTime, setSelectTime] = useState(null);
  const [selectTimeIdError, setSelectTimeIdError] = useState(false);
  const [errors, setErrors] = useState({});
  const [holidayDates, setHolidayDates] = useState([]);
  const holidays = useSelector((state) => state?.doctor?.holidays);
  const vetAvailability = useSelector(
    (state) => state?.clinic?.vetAvailability
  );
  const vetBookedApnts = useSelector((state) => state?.clinic?.vetBookedApnts);
  const clinicHolidays = useSelector((state) => state?.clinic?.holidays);
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);

  useEffect(() => {
    if (modalData) {
      const apnt = modalData?.appoinment;
      setBookValues({
        ...modalData,
        appointmentTime: apnt?.appointmentTime ?? apnt?.appointmentStartTime,
        appointmentId: apnt?.appointmentId,
        appointmentDate: apnt?.appointmentDate,
        bookingType: "Walk-in",
        consultationMode: apnt?.appointmentType,
        serviceType: apnt?.serviceType,
        reason: apnt?.reason,
        vetName: {
          name: modalData?.appoinment?.doctorName,
          value: modalData?.appoinment?.doctorId,
          id: modalData?.appoinment?.doctorId,
        },
        appointmentOption: apnt?.immediate ? "Immediate" : "Later",
        date: new Date(apnt?.appointmentDate),
      });
    }
  }, [modalData]);

  useEffect(() => {
    if (
      isReassign ||
      !bookValues?.vetName?.value ||
      !bookValues?.date ||
      !bookValues?.appointmentOption
    ) {
      return;
    }
    if (bookValues?.appointmentOption === "Later") {
      dispatch(getVetHolidaysById(bookValues?.vetName?.value));
      dispatch(
        getAvailabilityByVetIdAndType({
          vetId: bookValues?.vetName?.value,
          type: bookValues?.consultationMode,
        })
      );
      dispatch(
        getAppointmentsByVetIdAndDate({
          vetId: bookValues?.vetName?.value,
          date: moment(new Date(bookValues?.date)).format("YYYY-MM-DD"),
          clinicId: profile?.id,
        })
      );
    }
  }, [
    bookValues?.vetName?.value,
    bookValues?.date,
    bookValues?.appointmentOption,
    bookValues?.consultationMode,
  ]);

  useEffect(() => {
    getHolidayDateList();
  }, [holidays, clinicHolidays, vetAvailability]);

  const getHolidayDateList = () => {
    if (
      (holidays?.length === 0 || !holidays) &&
      (clinicHolidays?.length === 0 || !clinicHolidays) &&
      vetAvailability?.every((li) => li?.status)
    ) {
      return setHolidayDates([]);
    }
    const vetDates = getAllDatesFromArray(holidays) ?? [];
    const cliHolidays =
      clinicHolidays?.map((hl) => {
        return hl?.date;
      }) ?? [];
    const unAvilableDates =
      vetAvailability?.length > 0 ? getUpcoming60Dates(vetAvailability) : [];
    const mergedArray = vetDates?.concat(cliHolidays, unAvilableDates);
    setHolidayDates(uniq(mergedArray));
  };

  const handleChangeBookValue = (key, value) => {
    const reqValue =
      typeof value === "object"
        ? typeof value?.value === "number"
          ? value?.value?.toString()
          : value?.value
        : value;
    if (key === "appointmentOption" && value === "Immediate") {
      setSelectTimeIdError(false);
    }
    setBookValues({ ...bookValues, [key]: value });
    if (key === "vetName") {
      setBookValues({
        ...bookValues,
        [key]: value,
        assignedUsers: [],
      });
    }
    setErrors({
      ...errors,
      [key]: reqValue?.length > 0 ? false : "Required Field",
    });
  };

  const handleSelectTime = (time) => {
    setSelectTime(time?.startTime);
    setSelectTimeIdError(false);
  };

  const validateFields = () => {
    const newErrors = {};
    if (!bookValues?.vetName?.value)
      newErrors.vetName = "This field is required";
    if (!bookValues?.appointmentOption)
      newErrors.appointmentOption = "Appointment Type is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleReschedule = () => {
    if (
      !isReassign &&
      !selectTime &&
      bookValues?.appointmentOption !== "Immediate"
    ) {
      setSelectTimeIdError(true);
      return;
    }

    if (!validateFields()) return;

    dispatch(showLoader());
    const apntId = modalData?.appoinment?.appointmentId;
    const comObj = {
      doctorId: bookValues?.vetName?.value,
    };
    if (bookValues?.assignedUsers?.length > 0) {
      comObj.assignedUsers = bookValues?.assignedUsers?.map((li) => li?.value);
    }
    const data = {
      ...comObj,
      appointmentDate: moment(new Date(bookValues?.date)).format("YYYY-MM-DD"),
      immediate: bookValues?.appointmentOption === "Immediate",
      appointmentStartTime: selectTime,
    };
    if (!isReassign && bookValues?.appointmentOption !== "Immediate") {
      data.appointmentEndTime = adjustTime(
        selectTime,
        getTimeDiffInMins(
          modalData?.appoinment?.appointmentStartTime ??
            modalData?.appoinment?.appointmentTime ??
            modalData?.appoinment?.startTime,
          modalData?.appoinment?.appointmentEndTime ??
            modalData?.appoinment?.endTime
        )?.totalMinutes ?? 0
        // getRequiredSlotList({
        //   availability: vetAvailability,
        //   date: bookValues?.date,
        //   isDuration: true,
        // })
      );
    }

    dispatch(
      isReassign
        ? clinicReassignAppointment({ appointmentId: apntId, data: comObj })
        : clinicRescheduleAppointment({ appointmentId: apntId, data })
    ).then((res) => {
      dispatch(hideLoader());
      if (res?.payload) {
        onSuccess && onSuccess();
        onClose();
        setBookValues(initBookValues);
        setSelectTime(null);
        setSelectTimeIdError(false);
        setErrors({});
      }
    });
  };

  const getAllClinicUserListWoSelectedVet = (vetId) => {
    if (!vetId) return [];
    const reqVetList =
      clinicVets
        ?.filter((vl) => vl?.status === "Y" && vl?.doctorId !== vetId)
        ?.map((vet) => {
          return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
        }) ?? [];
    return reqVetList;
  };

  const handleClose = () => {
    onClose();
    setBookValues(initBookValues);
    setSelectTime(null);
    setSelectTimeIdError(false);
    setErrors({});
  };

  return (
    <CustomModal
      open={open}
      onClose={handleClose}
      header="Reschedule / Reassign"
      rightModal
      modalWidth={30}
      headerBold
    >
      <Grid container spacing={1} className="ph20 scroll-80vh">
        <Grid item xs={12}>
          <Card sx={cardSty} className="CustomCard-back-appointment">
            <div className="maint">
              <div className="flex-row">
                <Grid item xs={3}>
                  <div className="flex-center">
                    {modalData?.appoinment?.petImage ? (
                      <CardMedia
                        image={modalData?.appoinment?.petImage}
                        className="CustomCard-img3-bill"
                      />
                    ) : (
                      <div className="flex-center h50img">
                        <Typography className="font-bold fs30 white-color capitalize">
                          {modalData?.appoinment?.petName?.[0]}
                        </Typography>
                      </div>
                    )}
                  </div>
                </Grid>
                <div className="flex-row">
                  <div className="flex-start">
                    <div className="flex-column">
                      <div className="flex-row">
                        <div className="mb10 txt-semi-bold black fs14 capitalize">
                          {modalData?.appoinment?.petName}
                        </div>
                        <Typography
                          className={`ml5 text capitalize ${
                            modalData?.appoinment?.gender === "male"
                              ? "card-blue-color"
                              : "card-rose-color"
                          }`}
                        >
                          {`(${modalData?.appoinment?.gender})`}
                        </Typography>
                      </div>
                      <Typography className="mb10 txt-regular card-gray-color fs12">
                        {modalData?.appoinment?.breed}
                      </Typography>
                    </div>
                  </div>
                </div>
                <div></div>
              </div>
              <div>
                <div className="flex-row parentcontainer mt10">
                  <div className="flex-row iconcontainer">
                    <AccountCircleOutlinedIcon sx={{ width: 25, height: 25 }} />
                    <div className="txt-semi-bold fs14 capitalize">
                      {modalData?.appoinment?.userName}
                    </div>
                  </div>
                  <div className="meeting-doctor">
                    {moment(modalData?.appoinment?.appointmentDate).fromNow()} (
                    {modalData?.appoinment?.appointmentDate})
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <div className="txt-semi-bold fs14 light-grey">
            Booking Type <span className="red-color">*</span>
          </div>
          <Select value={bookValues?.bookingType} selectFixed />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <div className="txt-semi-bold fs14 light-grey">
            Consultation Mode <span className="red-color">*</span>
          </div>
          <Select value={bookValues?.consultationMode} selectFixed />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="txt-semi-bold fs14 light-grey">
            Service Type <span className="red-color">*</span>
          </div>
          <Select value={bookValues?.serviceType} selectFixed />
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="txt-semi-bold fs14 light-grey">
            Reason for visit <span className="red-color">*</span>
          </div>
          <Select value={bookValues?.reason} selectFixed />
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="txt-semi-bold fs14 light-grey mb10">
            Vet Name <span className="red-color">*</span>
          </div>

          <Select
            list={vets}
            handleChange={(e, value) => handleChangeBookValue("vetName", value)}
            name="vetName"
            search
            value={bookValues?.vetName}
            error={!!errors?.vetName}
            helperText={errors?.vetName}
            // label="Vet Name *"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="txt-semi-bold fs14 light-grey mb10">
            Assigned Users
          </div>

          <Select
            list={getAllClinicUserListWoSelectedVet(bookValues?.vetName?.value)}
            value={bookValues?.assignedUsers ?? []}
            name="assignedUsers"
            handleChange={(e) => {
              handleChangeBookValue("assignedUsers", e?.target?.value);
            }}
            multiSelectSearchCheck
          />
        </Grid>
        {isReassign ? null : (
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="txt-semi-bold fs14 light-grey">
              Appointment Time:{" "}
              {moment(
                new Date(modalData?.appoinment?.appointmentdateTime)
              ).format("DD MMM YYYY HH:mm")}
            </div>
          </Grid>
        )}
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="mbminus">
          <div className="flex-row">
            <div className="txt-semi-bold fs14 light-grey mt10">
              Appointment <span className="red-color">*</span> :
            </div>
            <div className="ml5">
              <CustomCheckbox
                radio
                value={bookValues?.appointmentOption}
                onChange={(e) =>
                  handleChangeBookValue("appointmentOption", e?.target?.value)
                }
                radios={isReassign ? appointmentList : appointmentLaterList}
                disabled={isReassign}
                defaultValue={bookValues?.appointmentOption}
              />
            </div>
          </div>

          {!!errors?.appointmentOption && (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography color="error" className="mt5 fs14">
                Appointment is Required
              </Typography>
            </Grid>
          )}
        </Grid>

        {!isReassign && bookValues?.appointmentOption === "Later" && (
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="txt-mont fs14 ">
              Date <span className="red-color">*</span>
            </div>
            <div className="mb20">
              <CustomTextField
                name="date"
                value={bookValues?.date}
                labelTop
                fullWidth
                handleChange={(e) =>
                  handleChangeBookValue("date", e?.target?.value)
                }
                mobileDateWithBatch
                markDateList={holidayDates ?? []}
              />
            </div>
          </Grid>
        )}

        {!isReassign &&
          bookValues?.appointmentOption === "Later" &&
          bookValues?.date &&
          getRequiredSlotList({
            availability: vetAvailability,
            date: bookValues?.date,
            bookedApnts: vetBookedApnts,
            holidays,
          })?.length > 0 &&
          getRequiredSlotList({
            availability: vetAvailability,
            date: bookValues?.date,
            bookedApnts: vetBookedApnts,
            holidays,
          })?.map((item, i) => {
            return (
              <div className="flex-row" key={i + item?.startTime}>
                <div
                  onClick={() => handleSelectTime(item)}
                  className={
                    selectTime === item?.startTime
                      ? "bgContainerSelected cursor"
                      : "bgContainerUnselected cursor"
                  }
                >
                  {item?.startTime}
                </div>
              </div>
            );
          })}

        {selectTimeIdError && (
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography color="error" className="mt5 fs14">
              Time is Required
            </Typography>
          </Grid>
        )}
      </Grid>
      <div className="flex1-end mt20">
        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
          <CustomButton text="Save" onClick={handleReschedule} smallBtn />
        </Grid>
      </div>
    </CustomModal>
  );
};

export default RescheduleReassign;
